// Service to help the user calculate minimum suggested download speed
export function onlyUnique(value: number | string | undefined, index: number, self: any) {
  return self.indexOf(value) === index;
}
